import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[anpBrokenImg]',
    standalone: false
})
export class BrokenImgDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('error') public errorListener(): void {
    const element = this.elementRef.nativeElement as HTMLImageElement;
    element.src = 'assets/no-image.png';
  }
}
